"use client";

import React, { Fragment, ReactElement } from 'react';
import { Asset, Category, Post } from '../../../../../packages/types/payload-types';
import Container from '@telesoft/ui/components/ui/container';
import PageHeader from '@telesoft/ui/components/ui/page-header';
import Divider from '@telesoft/ui/blocks/Divider';
import ResourceGridSection from '@telesoft/ui/components/sections/resource-grid-section';
import { ASSET_URL } from '@telesoft/lib/web/constants';
import CallToActionNucleus from '@telesoft/ui/containers/call-to-action-nucleus';

interface Props {
  category: Category & { image?: Asset };
  categorySlug: string;
  posts: Post[];
  isPreview?: boolean;
}

export default function ContentPage({
  category,
  posts: data,
}: Props): ReactElement {
  return (
    <Fragment>
      <PageHeader
        pageHeader={category?.title}
        pageSubHeader="RESOURCES"
        backgroundUrl={ASSET_URL + '/' + category.image.filename}
      />
      <Container>
        <Divider />
        <ResourceGridSection data={data} />
      </Container>
      <Divider withLine={true} />
      <CallToActionNucleus />
    </Fragment>
  );
}
